<template>
    <Primitive
        :as="as"
        :class="classes"
    >
        <KEyebrow
            v-if="$slots.eyebrow || eyebrow"
            :variant="eyebrowVariant"
            :class="element('eyebrow')"
        >
            <slot name="eyebrow">
                {{ eyebrow }}
            </slot>
        </KEyebrow>

        <div
            v-if="$slots.title || title || $slots.default || text || $slots.actions"
            :class="element('content')"
        >
            <div :class="element('main')">
                <component
                    :is="titleAs"
                    v-if="$slots.title || title"
                    class="k-heading-2"
                    :class="[element('title')]"
                >
                    <slot name="title">
                        {{ title }}
                    </slot>
                </component>

                <div
                    v-if="$slots.default || text"
                    class="k-text-lg k-prose"
                    :class="[element('text')]"
                >
                    <slot>{{ text }}</slot>
                </div>
            </div>

            <div
                v-if="$slots.actions"
                :class="element('actions')"
            >
                <slot name="actions" />
            </div>
        </div>
    </Primitive>
</template>

<script setup lang="ts">
import type { KSectionHeaderProps } from './types'
import useBem from '@yeeroen/use-bem'
import { Primitive } from 'reka-ui'

import { computed } from 'vue'
import KEyebrow from '../eyebrow/k-eyebrow.vue'

defineOptions({ name: 'KSectionHeader' })

const props = withDefaults(defineProps<KSectionHeaderProps>(), {
    as: 'header',
    eyebrowVariant: 'pill',
    titleAs: 'h2',
    align: 'center',
})

defineSlots<{
    default?: () => unknown
    actions?: () => unknown
    eyebrow?: () => unknown
    title?: () => unknown
}>()

const { block, element, modifier } = useBem('k-section-header')

const classes = computed(() => block(
    modifier(props.align),
))
</script>

<style lang="scss">
@use './k-section-header.scss';
</style>
